"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrefsFromPartial = exports.DEFAULT_PREFS = exports.Prefs = exports.Theme = exports.ScreensaverTimeoutDurationOptionFromMillis = exports.SCREENSAVER_TIMEOUTS_MILLIS = exports.SystemOfUnits = exports.SafeLanguage = exports.LanguageFromLegacyLanguage = exports.Language = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../../schema");
const time_1 = require("../../../../time");
const Timezone = __importStar(require("../../../../timezone"));
const Unit = __importStar(require("../../../../unit"));
const NAMESPACE = 'Culligan.Device.Class.Pelican2.Prefs';
exports.Language = effect_1.Schema.Literal('en-US', // English (US)
'en-GB', // English (GB)
'nl-NL', // Dutch
'es-ES', // Spanish
'fr-FR', // French
'it-IT', // Italian
'ko-KR').annotations({
    identifier: `${NAMESPACE}.Language`,
    pretty: () => language => ({
        'en-US': 'English (US)',
        'en-GB': 'English (GB)',
        'nl-NL': 'Dutch (Netherlands)',
        'es-ES': 'Spanish (Spain)',
        'fr-FR': 'French (France)',
        'it-IT': 'Italian (Italy)',
        'ko-KR': 'Korean (South-Korea)',
    })[language],
});
exports.LanguageFromLegacyLanguage = effect_1.Schema.transformLiterals(...[
    ['en', 'en-US'], // English (US)
    ['uk', 'en-GB'], // English (GB)
    ['nl', 'nl-NL'], // Dutch
    ['es', 'es-ES'], // Spanish
    ['fr', 'fr-FR'], // French
]).annotations({
    identifier: `${NAMESPACE}.LanguageFromLegacyLanguage`,
});
exports.SafeLanguage = effect_1.Schema.Union(exports.Language, exports.LanguageFromLegacyLanguage).annotations({
    identifier: `${NAMESPACE}.SafeLanguage`,
});
exports.SystemOfUnits = Unit.Common.System.pipe(effect_1.Schema.pickLiteral('SI', 'US')).annotations({
    identifier: `${NAMESPACE}.SystemOfUnits`,
    ...effect_1.Record.getSomes({
        pretty: effect_1.SchemaAST.getAnnotation(effect_1.SchemaAST.PrettyAnnotationId)(Unit.Common.System.ast),
    }),
});
exports.SCREENSAVER_TIMEOUTS_MILLIS = [
    60_000, // 1 minute
    120_000, // 2 minutes
    300_000, // 5 minutes
    600_000, // 10 minutes
];
exports.ScreensaverTimeoutDurationOptionFromMillis = (0, schema_1.OptionFromZeroOr)((0, time_1.makeDurationFromMillis)(...exports.SCREENSAVER_TIMEOUTS_MILLIS)).annotations({
    identifier: `${NAMESPACE}.ScreensaverTimeoutDurationOptionFromMillis`,
});
exports.Theme = effect_1.Schema.transformLiterals(['LIGHT', 'Light'], ['DARK', 'Dark']).annotations({
    identifier: `${NAMESPACE}.Theme`,
});
exports.Prefs = effect_1.Schema.Struct({
    alcoveLight: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).pipe(effect_1.Schema.fromKey('ALCOVE_LIGHT')).annotations({
        title: 'Alcove Light Enabled',
        description: 'Whether the alcove light will activate during the dispense flow',
    }),
    language: effect_1.Schema.propertySignature(exports.SafeLanguage).pipe(effect_1.Schema.fromKey('LANGUAGE')).annotations({
        title: 'Language',
        description: 'The language of the text used throughout the application',
    }),
    systemOfUnits: effect_1.Schema.propertySignature(exports.SystemOfUnits).pipe(effect_1.Schema.fromKey('SYSTEM_OF_UNITS')).annotations({
        title: 'System of Units',
        description: 'The system of units the device will use to display measurements',
    }),
    screensaverTimeout: effect_1.Schema.propertySignature(exports.ScreensaverTimeoutDurationOptionFromMillis)
        .pipe(effect_1.Schema.fromKey('SCREENSAVER_TIMEOUT'))
        .annotations({
        title: 'Screensaver Timeout',
        description: 'The duration of inactivity after which the screen will automatically return to the screensaver',
    }),
    hotEnabled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).pipe(effect_1.Schema.fromKey('HOT_ENABLED')).annotations({
        title: 'Hot Enabled',
        description: 'Whether dispensing hot water has been enabled',
    }),
    theme: effect_1.Schema.propertySignature(exports.Theme).pipe(effect_1.Schema.fromKey('THEME')).annotations({
        title: 'Theme',
        description: 'The color theme the unit is using',
    }),
    timezone: effect_1.Schema.propertySignature(Timezone.TimezoneFromTimezoneName)
        .pipe(effect_1.Schema.fromKey('TIMEZONE'))
        .annotations({
        title: 'Timezone',
        description: 'The timezone used by the unit to report data to the cloud, and render the clock.',
    }),
    sparklingFlowMeterInstalled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean)
        .pipe(effect_1.Schema.fromKey('SPARKLING_FLOW_METER_INSTALLED'))
        .annotations({
        title: 'Sparkling Flow Meter Installed',
        description: 'Whether this unit relies on a dedicated sparkling water flow meter to determine the flow rate of sparkling water. ' +
            'If false, the unit will assume the flow rate of a perfectly calibrated carbonator flow restrictor.',
    }),
    co2FlowMeterInstalled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean)
        .pipe(effect_1.Schema.fromKey('CO2_FLOW_METER_INSTALLED'))
        .annotations({
        title: 'CO₂ Flow Meter Installed',
        description: 'Whether this unit relies on a CO₂ flow meter to track the depletion of the CO₂ tank. ' +
            'If false, the unit will infer CO₂ usage from the volume of sparkling water dispensed.',
    }),
}).annotations({
    identifier: `${NAMESPACE}.Prefs`,
});
/* eslint-enable no-restricted-syntax */
exports.DEFAULT_PREFS = {
    alcoveLight: true,
    language: 'en-US',
    systemOfUnits: 'US',
    screensaverTimeout: effect_1.Option.some(effect_1.Duration.minutes(2)),
    hotEnabled: false,
    theme: 'Light',
    timezone: effect_1.Schema.decodeSync(Timezone.TimezoneFromTimezoneName)('UTC'),
    sparklingFlowMeterInstalled: false,
    co2FlowMeterInstalled: false,
};
exports.PrefsFromPartial = (0, schema_1.StructFromPartial)(exports.DEFAULT_PREFS)(exports.Prefs).annotations({
    identifier: `${NAMESPACE}.PrefsFromPartial`,
});
//# sourceMappingURL=prefs.js.map